module.exports = __webpack_public_path__ + "img/Coleta manual de ramos podados.3ed8e7d7.webp";